export default {
      id: "simplearrow-usage",
      viewBox: "0 0 49.68 30.23",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#simplearrow-usage",
      toString: function () {
        return this.url;
      }
    }